import "./App.css";
import MessagePage from "./components/pages/MessagePage";

function App() {
	return <MessagePage />;
}

export default App;
